import { createFileRoute } from "@tanstack/react-router";
import Motociclete from "@/pages/Motociclete";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/uk/motorcycles/")({
  head: () => routeHead("/uk/motorcycles/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Motociclete />
  );
}
